import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { fonts, spacing } = theme;

export const primaryLabel = css`
  margin: 0;
  padding: ${spacing.base}px ${spacing.xs}px;
  border-radius: 0 6px 6px 0;
  ${theme.responsiveText.BODY.SM}
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
`;

export const unavailableLabel = css`
  background-color: var(--neutral-white-base);
  color: var(--brand-bluple-base);
`;

export const outOfStockLabel = css`
  background-color: var(--neutral-white-base);
  color: var(--brand-bluple-base);
`;

export const saleLabel = css`
  background-color: var(--functional-red-base);
  color: var(--neutral-white-base);
`;

export const newLabel = css`
  background-color: var(--brand-bluple-base);
  color: var(--neutral-white-base);
`;
